import CreateGift from '@/services/gifting/CreateGift';
import FetchPrices from '@/services/gifting/FetchPrices';
import FetchDeliveryDays from '@/services/gifting/FetchDeliveryDays';
import SendIncompleteGiftingData from '@/services/gifting/SendIncompleteGiftingData';

export default class GiftingService {
    createGift(payload) {
        return (new CreateGift()).handle(payload);
    }

    fetchPrices() {
        return (new FetchPrices()).handle();
    }

    fetchDeliveryDays() {
        return (new FetchDeliveryDays()).handle();
    }
    async sendIncompleteGiftingData(giftingData, giftingId, userId) {
        return await (new SendIncompleteGiftingData()).handle(giftingData, giftingId, userId);
    }
}
